var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "gs1-alert",
        {
          attrs: {
            alertClass: "success",
            iconClass: "fa fa-check-circle color-forest"
          }
        },
        [
          _c("i18n", { attrs: { path: "registered_to", tag: "p" } }, [
            _vm._v("\n      " + _vm._s(_vm.companyName) + "\n    ")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.$t("title")))]),
      _vm._v(" "),
      _c("i18n", { attrs: { path: "message", tag: "p" } }, [
        _c(
          "a",
          {
            attrs: {
              href: "https://www.gs1-germany.de/service/kontakt/",
              target: "_blank",
              rel: "noopener"
            }
          },
          [_vm._v(_vm._s(_vm.$t("contact_gs1")))]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d854b890", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d854b890","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResultNoData.vue
// module id = null
// module chunks = 